import { Card, CardContent } from '@ovComponents/2-component/card/card';
import { generateComparativeValue } from '@utils/formatting';
import { Box, Skeleton, Typography, useTheme } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';

export const NumberWidget = ({
  title,
  newValue,
  oldValue,
  loading,
  isCurrency = true,
  isPercentage = false,
}: {
  title: string;
  newValue: number;
  oldValue: number;
  loading: boolean;
  isCurrency?: boolean;
  isPercentage?: boolean;
}) => {
  const { t } = useTranslation('homePageConfiguration');
  const { value, isIncrease, changeText } = generateComparativeValue(
    newValue,
    oldValue,
    isCurrency,
    isPercentage,
    t('practiceOverview.fromLastMonth'),
  ) ?? { value: '', isIncrease: false, changeText: '' };
  const theme = useTheme();
  return (
    <Card sx={{ flex: 1, height: '170px' }}>
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: 'calc(100% - 32px)',
        }}
      >
        <Typography variant='bodyLarge' color='textSecondary'>
          {title}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {loading ? (
            <Skeleton variant='text' width='70%' height='24px' />
          ) : (
            <Typography
              variant='displayMedium'
              sx={{ fontVariantNumeric: 'tabular-nums' }}
            >
              {value}
            </Typography>
          )}
          {changeText && (
            <Typography
              variant='bodySmall'
              sx={{
                color: isIncrease ? theme.color.positive : theme.color.negative,
              }}
            >
              {changeText}
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};
